var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FED955",
    d: "M15 25h-5v-5h5zM15 35h-5v-5h5zM15 30h-5v-5h5zM15 40h-5v-5h5zM35 15h-5v-5h5zM35 45h-5v5h5zM40 15h-5v-5h5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M45 15h-5v-5h5zM15 15h5v-5h-5zM45 45h5v-5h-5zM15 45h-5v-5h5zM40 10h-5V5h5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M40 5h-5V0h5zM40 60h-5v-5h5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M40 55h-5v-5h5zM30 10h-5V5h5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M30 5h-5V0h5zM30 60h-5v-5h5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M30 55h-5v-5h5zM35 10h-5V5h5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M35 5h-5V0h5zM35 60h-5v-5h5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M35 55h-5v-5h5zM25 10h-5V5h5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M25 5h-5V0h5zM25 60h-5v-5h5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M25 55h-5v-5h5zM50 20h-5v-5h5zM10 20h5v-5h-5zM40 50h5v-5h-5zM20 50h-5v-5h5zM55 25h-5v-5h5zM10 25H5v-5h5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M5 25H0v-5h5zM10 20H5v-5h5zM50 20h5v-5h-5zM45 55h-5v-5h5zM5 45v-5h5v5zM15 15h-5v-5h5zM45 15h5v-5h-5zM50 50h-5v-5h5zM10 50v-5h5v5zM20 10h-5V5h5zM40 10h5V5h-5zM55 45h-5v-5h5zM15 55v-5h5v5zM60 25h-5v-5h5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M55 30h-5v-5h5zM10 30H5v-5h5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M5 30H0v-5h5zM60 30h-5v-5h5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M55 35h-5v-5h5zM10 35H5v-5h5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M5 35H0v-5h5zM60 35h-5v-5h5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9695F8",
    d: "M55 40h-5v-5h5zM10 40H5v-5h5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M5 40H0v-5h5zM60 40h-5v-5h5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED955",
    d: "M40 45h-5v5h5zM35 25h-5v-5h5zM35 35h-5v-5h5zM35 40h-5v-5h5zM35 20h-5v-5h5zM35 40h-5v5h5zM25 35h-5v-5h5zM25 30h-5v-5h5zM25 40h-5v-5h5zM25 20h-5v-5h5zM25 40h-5v5h5zM40 35h-5v-5h5zM40 30h-5v-5h5zM40 40h-5v-5h5zM40 20h-5v-5h5zM40 40h-5v5h5zM30 15h-5v-5h5zM30 45h-5v5h5zM25 15h-5v-5h5zM25 45h-5v5h5zM30 25h-5v-5h5zM30 35h-5v-5h5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#5552FD",
    d: "M25 25h-5v-5h5zM35 30h-5v-5h5zM45 25h-5v-5h5zM45 35h-5v-5h5zM45 30h-5v-5h5zM45 40h-5v-5h5zM45 20h-5v-5h5zM45 40h-5v5h5zM20 25h-5v-5h5zM20 35h-5v-5h5zM20 30h-5v-5h5zM20 40h-5v-5h5zM20 20h-5v-5h5zM20 40h-5v5h5zM40 25h-5v-5h5zM30 30h-5v-5h5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED955",
    d: "M30 40h-5v-5h5zM30 20h-5v-5h5zM30 40h-5v5h5zM50 25h-5v-5h5zM50 35h-5v-5h5zM50 30h-5v-5h5zM50 40h-5v-5h5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMim);
export default __webpack_public_path__ + "static/media/mim.89db5b285d50b27cc9554b080d7e2d82.svg";
export { ForwardRef as ReactComponent };